import Item from './Item.model';

let _ = window._;
let Backbone = window.Backbone;
let sfspcaUserContent = window.sfspcaUserContent;

export default Backbone.PageableCollection.extend({
  model: Item,
  url: sfspcaUserContent.restURL,
  searchTerm: '',
  filters: [],

  syncXhr: null,
  alterHistory: sfspcaUserContent.alterHistory,

  initialize: function() {
    // this.fetch();
  },

  parseRecords: function(resp) {
    return resp.items;
  },

  parseState: function(resp) {
    return {
      totalRecords: resp.total
    };
  },

  searchQuery: function(term) {
    this.searchTerm = term;
  },

  updateFilters: function(filters = []) {
    this.filters = filters;
  },

  sync: function(method, collection, options = {}) {
    options.data = _.extend({
      'search-stories': '',
      filters: []
    }, options.data);

    console.log(this.searchTerm);
    if(this.searchTerm !== '') {
      options.data['search-stories'] = this.searchTerm;
    }

    if(this.filters.length) {
      options.data.filters = this.filters;
    }

    try {
      this.syncXhr.abort();
    } catch(err) {
      //
    }

    this.syncXhr = Backbone.PageableCollection.prototype.sync.apply(this, [method, collection, options]);

    this.syncXhr.done(() => {
      if (this.alterHistory) {
        this.alterHash(options.data);
      }
    })

    return this.syncXhr;
  },

  loadMore: function() {
    this.getNextPage();
  },

  alterHash: function(data) {
    let hash = {
      'search-stories': data['search-stories'],
      page: this.state.currentPage,
      filters: []
    };

    let filters = {}

    if(data.filters.length) {
      _.each(data.filters, (filter) => {
        filters[filter.taxonomy.name] = filters[filter.taxonomy.name] || [];

        filters[filter.taxonomy.name].push(filter.id)
      });

      _.each(Object.keys(filters), (key) => {
        hash.filters.push(key + '=' + filters[key].join(','));
      });

      hash.filters = hash.filters.join(';');
    }

    let href = [];

    _.each(Object.keys(hash), (key) => {
      if(hash[key] !== '') {
        href.push(key + '=' + hash[key]);
      }
    });

    let oldHref = window.location.href;
    let oldSearch = window.location.search;

    oldHref = oldHref.replace(oldSearch, '');
    oldHref += '?' + href.join('&');

    if(window.history && window.history.pushState) {
      window.history.pushState({}, '', oldHref);
    }
  },

  state: {
    pageSize: parseInt(sfspcaUserContent.postsPerPage, 10),
    currentPage: parseInt(sfspcaUserContent.currentPage, 10) || 1,
  },
});


// WEBPACK FOOTER //
// ./assets/src/javascripts/userContent/grid/Items.collection.js